import React, { useState } from 'react'
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import { createInquiry } from '../../API/inquiryAPI';

const FormSection = () => {

    const [error, setError] = useState("");
    const [recaptchaValue, setRecaptchaValue] = useState(null);

    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
      };

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormData({ ...formData, [name]: value });
    
        if (name === "email") {
            if (validateEmail(value)) {
                setError("");
            } else {
                setError("Please enter a valid email address.");
            }
        }
    };

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: ''
    });
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!recaptchaValue) {
            alert("Please complete the CAPTCHA");
            return;
          }
    
        // Validate email before proceeding
        if (!validateEmail(formData.email)) {
            setError("Please enter a valid email address.");
            Swal.fire({
                icon: 'error',
                title: 'Invalid Email',
                text: 'Please enter a valid email address.',
            });
            return;
        }

        const inquiryData = {
            name: `${formData.firstName} ${formData.lastName}`,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
        };
    
        try {
            const response = await createInquiry(inquiryData);
    
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Submission Successful',
                    text: 'Your inquiry has been submitted successfully!',
                });

                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    subject: '',
                    message: '',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Submission Failed',
                    text: 'Failed submission. Please try again.',
                });
            }
        } catch (error) {
            console.error('API Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred. Please try again.',
            });
        }
    };
    

  return (
    <section className="w-full flex flex-col justify-center items-center bg-[#F5E9D7]">
        <div className='w-full pt-10 md:py-10'>
            <h1 className='font-bold font-playfair text-5xl md:text-6xl text-center text-[#41220E]'>Write To Us</h1>
        </div>
        <div className='w-[70%] xl:w-[60%] mb-10 md:py-10'>
            <div className='w-full mt-10 lg:mt-0 lg:px-10 2xl:px-[5rem]'>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2 lg:mt-9">
                        <div>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] boder-solid border-2 border-[#D4A373]/50 bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                placeholder="First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] boder-solid border-2 border-[#D4A373]/50 bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                placeholder="Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="mt-4 lg:mt-8">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] boder-solid border-2 border-[#D4A373]/50 bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                    <div className="mt-4 lg:mt-8">
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] boder-solid border-2 border-[#D4A373]/50 bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                            placeholder="Subject"
                            value={formData.subject}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mt-4 lg:mt-8">
                        <textarea
                            id="message"
                            name="message"
                            rows="4"
                            className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] boder-solid border-2 border-[#D4A373]/50 bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                    <div>
                        <ReCAPTCHA
                        sitekey="6Lc0_J0qAAAAALj8EKQKFG1Uj2sDGkSyvvS47g4P"
                        onChange={handleRecaptchaChange}
                        />
                    </div>
                    <div className="mt-6 lg:mt-9">
                        <button
                            type="submit"
                            className={`w-full bg-[#D4A373] text-white font-bold text-[20px] py-2 lg:py-4 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4A373] ${
                            recaptchaValue
                                ? "hover:bg-[#c2905f] disabled:cursor-pointer"
                                : "bg-[#be9367] cursor-not-allowed"
                            }`}
                            disabled={!recaptchaValue}>
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
        
    </section>
  )
}

export default FormSection
